import Transaction from ".";
import Ticket from ".";

export const transactionRoutes = (data) => [
  {
    path: "/:lang/admin/transaction",
    title: "Page",
    layout: "admin",
    routeType: "admin",
    component: Transaction,
  },
];